module.exports = __webpack_public_path__ + "img/751.4c038f24.png";